import FormField from "../FormInputs/FormField.js";
import {
  HOUSE_HANDICAP_BASE,
  HOUSE_HANDICAP_MAX,
  HOUSE_HANDICAP_PERCENTAGE,
} from "../../utility/houseTournamentDefaults";
import {
  SCORING_HANDICAP,
  SCORING_SCRATCH,
} from "../../utility/tournamentScoringType";

export const ScoringTypeToggle = ({ name, value, onChange }) => (
  <fieldset className="space-y-2 mb-4">
    <legend className="block text-sm font-medium text-brand-charcoal mb-2">
      Scoring
    </legend>
    <label className="flex items-start gap-2 text-sm text-brand-charcoal">
      <input
        type="radio"
        name={name}
        className="mt-1"
        checked={value === SCORING_HANDICAP}
        onChange={() => onChange(SCORING_HANDICAP)}
      />
      <span>Handicap</span>
    </label>
    <label className="flex items-start gap-2 text-sm text-brand-charcoal">
      <input
        type="radio"
        name={name}
        className="mt-1"
        checked={value === SCORING_SCRATCH}
        onChange={() => onChange(SCORING_SCRATCH)}
      />
      <span>Scratch</span>
    </label>
  </fieldset>
);

const HandicapFields = ({
  scoringType = SCORING_HANDICAP,
  setScoringType,
  handicapBase,
  setHandicapBase,
  handicapPercentage,
  setHandicapPercentage,
  handicapMax,
  setHandicapMax,
  errorMessages,
  scoringName = "tournament-scoring",
}) => {
  return (
    <>
      <ScoringTypeToggle
        name={scoringName}
        value={scoringType}
        onChange={setScoringType}
      />
      {scoringType === SCORING_HANDICAP ? (
        <>
          <FormField
            label="Handicap Base"
            type="number"
            value={handicapBase}
            onChange={(e) => setHandicapBase(e.target.value)}
            placeholder={String(HOUSE_HANDICAP_BASE)}
            error={errorMessages.handicapBase}
          />
          <FormField
            label="Handicap Percentage"
            type="number"
            value={handicapPercentage}
            onChange={(e) => setHandicapPercentage(e.target.value)}
            placeholder={String(HOUSE_HANDICAP_PERCENTAGE)}
            error={errorMessages.handicapPercentage}
          />
          <FormField
            label="Maximum handicap"
            type="number"
            value={handicapMax}
            onChange={(e) => setHandicapMax(e.target.value)}
            placeholder={String(HOUSE_HANDICAP_MAX)}
            error={errorMessages.handicapMax}
          />
          <p className="text-xs text-brand-muted -mt-2 mb-4">
            Leave Maximum handicap blank for no cap.
          </p>
        </>
      ) : null}
    </>
  );
};

export default HandicapFields;
